import api from '../token';

export const FecharTurno = async (dados) => {
  try {
    const response = await api.post('/fecharTurno', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};